import { fn_managerReset, fn_select_quick_addr } from "function/FnBodySetting";
import { program_use_list } from "http/SettingConn";

export interface MenuConfig {
  key: string;
  label: string;
  link: string;
  analyticEvent: string;
  onClick?: (rootStore: any) => void; // 추가 클릭 핸들러
  showInNonMainPos?: boolean; // 메인 포스가 아닐 때 표시 여부
}

// 메뉴 설정 데이터
export const MenuConfigs: MenuConfig[] = [
  {
    key: "use",
    label: "주문현황 및 알림",
    link: "/setting/default/use",
    analyticEvent: "settingDashboard",
    showInNonMainPos: true,
  },
  {
    key: "receipt",
    label: "주문접수 및 연동",
    link: "/setting/default/receipt",
    analyticEvent: "settingOrderLink",
    onClick: rootStore => program_use_list(rootStore),
  },
  {
    key: "address",
    label: "주소키워드 설정",
    link: "/setting/default/address",
    analyticEvent: "settingAddrKeyword",
    onClick: rootStore => fn_select_quick_addr(rootStore),
  },
  {
    key: "delivery",
    label: "배달대행사 관리",
    link: "/setting/default/delivery",
    analyticEvent: "settingAgentDelivery",
    onClick: rootStore => rootStore.layerStore.setLayerDlvConnectView(false),
  },
  {
    key: "self_delivery",
    label: "자체배달원 관리",
    link: "/setting/default/self_delivery",
    analyticEvent: "settingSelfDelivery",
  },
  {
    key: "request_memo",
    label: "요청메시지 관리",
    link: "/setting/default/request_memo",
    analyticEvent: "settingMessage",
  },
  {
    key: "printer_setting",
    label: "프린터 설정",
    link: "/setting/default/printer_setting",
    analyticEvent: "settingPrinter",
    showInNonMainPos: true,
  },
  {
    key: "manager_setting",
    label: "관리자 설정",
    link: "/setting/default/manager_setting",
    analyticEvent: "settingAdministrator",
    onClick: rootStore => fn_managerReset(rootStore),
  },
];
